<app-header [musicplayer]="type"></app-header>
<div
  class="wrapper"
  infiniteScroll
  [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="150"
  (scrolled)="onScroll()"
  [infiniteScrollDisabled]="shimarStatus"
>
  <div class="container" *ngIf="homeData?.partnar_info?.id">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-12 col-md-12">
        <div class="partner-profile-detail">
          <div class="partner-profile">
            <div class="ratio-slider ratio-1-1">
              <img
                *ngIf="homeData?.partnar_info?.image"
                [src]="[homeData.partnar_info.image]"
              />
              <img
                *ngIf="!homeData?.partnar_info?.image"
                [src]="[app_constant.userNoImage]"
              />
            </div>
          </div>
          <div class="user-detail">
            <h1>{{ homeData?.partnar_info?.name }}</h1>
            <p
              class="text-secondary"
              *ngIf="homeData?.partnar_info?.total_content"
            >
              Videos <span class="dots"></span>
              {{ homeData?.partnar_info?.total_content }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section
    class="related-search upcoming pt-4"
    *ngIf="!shimarStatus && subcategory?.length > 0"
  >
    <div class="container">
      <div class="section-head">
        <h2>{{ apiParam.slug | removeDash }}</h2>
      </div>
      <div class="row custome-set">
        <div
          class="song-list-grid"
          *ngFor="let data of subcategory; let i = index"
        >
          <app-grid [data]="data" [gridType]="'square'"></app-grid>
        </div>
      </div>
    </div>

    <div class="w-100" *ngIf="loadMore">
      <app-grid-simmer class="search-page"></app-grid-simmer>
    </div>
  </section>
  <div
    class="record-not-available"
    *ngIf="subcategory?.length === 0 && !shimarStatus"
  >
    <div class="text-center">
      <img src="assets/images/no-recoard-playlist.png" />
      <p class="no-recored-content text-secondary">
        {{ "RECORD_NOT_FOUND" | translate }}
      </p>
    </div>
  </div>

  <app-grid-simmer class="search-page" *ngIf="shimarStatus"></app-grid-simmer>
</div>
<app-footer></app-footer>
